export default "__VITE_ASSET__c9a2bcf3__"